import { ChangeDetectorRef, Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { PersonService } from 'app/services/models/person.service';
import { TransactionProductService } from 'app/services/models/transaction-product.service';
import { TransactionService } from 'app/services/models/transaction.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-company-detail-transaction-list',
  templateUrl: './company-detail-transaction-list.component.html',
  styleUrls: ['./company-detail-transaction-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CompanyDetailTransactionListComponent implements OnInit {
  @BlockUI('section-block') blockUI: NgBlockUI;
  @BlockUI('section-block2') blockUI2: NgBlockUI;

  kindId = 8;
  constructor(
    private transactionManagementService: TransactionService,
    private activatedRouter: ActivatedRoute,
    private transactionProductService: TransactionProductService,
    private changeDetector: ChangeDetectorRef,
    private router: Router) { }
  companyId = null;
  rows: any;
  public pageBasic = 1;
  public selectedSize = 5;
  public basicSelectedOption: number = 5;
  totalCount: Number = 0;
  public ColumnMode = ColumnMode;
  @ViewChild('tableRowDetails') tableRowDetails: any;

  async ngOnInit() {
    this.activatedRouter.params.subscribe(params => {
      this.companyId = params['id'];
    })
    console.log(this.companyId);
    await this.getAllTransactionCompanies(this.pageBasic - 1, this.selectedSize, this.kindId, this.companyId);
  }

  expandedRow: any;  // Genişletilen satırı takip etmek için bir değişken ekliyoruz
  products: any[] = [];

  onActivate(event: any) {
    if (event.type === 'click' && event.row) {
      console.log(event.row.kindId);
      if (event.row.kindId == 6) {
        this.router.navigate([`/admin/sales-detail/${event.row.id}`]);
      }
      if (event.row.kindId == 5) {
        this.router.navigate([`/admin/buying-detail/${event.row.id}`]);
      }
      if (event.row.kindId == 8) {
        this.router.navigate([`/admin/offer-detail/${event.row.id}`]);
      }
    }
  }

  async rowDetailsToggleExpand(row) {
    this.products = [];
    // Eğer tıklanan satır zaten genişletilmişse, onu kapatalım
    await this.getByIdTransactionProducts(row.id);
    if (this.expandedRow === row) {
      this.tableRowDetails.rowDetail.toggleExpandRow(row);
      this.expandedRow = null;  // Satır kapatıldı, expandedRow'u sıfırlıyoruz
      return;
    }

    // Diğer satırları kapatalım
    if (this.expandedRow) {
      this.tableRowDetails.rowDetail.toggleExpandRow(this.expandedRow);
    }

    // Yeni satırı genişletelim

    this.tableRowDetails.rowDetail.toggleExpandRow(row);

    this.expandedRow = row;  // Genişletilen satırı takip etmek için kaydediyoruz
    console.log(this.expandedRow);
  }

  get rowHeight(): number {
    const length = this.products?.length || 0;

    if (length < 4) {
      return length * 110; // 5'ten küçükse 120 ile çarp
    } else if (length >= 4 && length <= 15) {
      return length * 57; // 5 ile 15 arasında ise 55 ile çarp
    } else {
      return length * 43; // 15'ten büyükse 35 ile çarp
    }
  }


  async getByIdTransactionProducts(id) {
    this.blockUI2.start("İşlem ürünleri yükleniyor...")
    const products = await this.transactionProductService.transactionManagementTransactionProductsById(id);
    console.log(products);
    this.products = products
    this.blockUI2.stop();
  }

  getTransactionName(kindId) {
    if (kindId == 8) {
      return "Teklifler";
    }
    else if (kindId == 6) {
      return "Satışlar"
    } else if (kindId == 5) {
      return "Alışlar"
    } else {
      return "Bilinmiyor"
    }
  }

  async onSelectKind(value: number) {
    this.kindId = value;
    console.log(this.kindId); // Seçilen değeri kontrol etmek için
    await this.getAllTransactionCompanies(this.pageBasic - 1, this.selectedSize, this.kindId, this.companyId);

  }

  async getAllTransactionCompanies(page, size, kindId, companyId) {
    this.blockUI.start()
    try {
      const data = await this.transactionManagementService.getAllTransactionCompany(page, size, this.kindId, companyId);
      this.rows = data.transactionManagements;
      console.log(data);
      this.totalCount = data.totalCount;
    } catch (error) {
    }
    this.blockUI.stop()
  }

  async onPageChange(pageNumber: number) {
    await this.getAllTransactionCompanies(this.pageBasic - 1, this.selectedSize, this.kindId, this.companyId);
  }
  async onOptionChange() {

    this.selectedSize = Number(this.basicSelectedOption)
    await this.getAllTransactionCompanies(this.pageBasic - 1, this.selectedSize, this.kindId, this.companyId);
  }

  calculateTotal(count: number, price: number, discountRate: number, taxRate: number): number {
    let total = count * price;
    if (discountRate) {
      total -= (total * discountRate) / 100; // İndirimi düş
    }
    if (taxRate) {
      total += (total * taxRate) / 100; // Vergiyi ekle
    }
    return total;
  }
}
